<template>
  <v-list>
    <v-list-item :link="false">
      <v-list-item-content>
        <v-list-item-subtitle>
          Название:
        </v-list-item-subtitle>
        <v-text-field solo flat v-model="activeSpeech.name" prepend-inner-icon="mdi-rename-box"></v-text-field>
        <v-list-item-subtitle>
          Описание:
        </v-list-item-subtitle>
        <v-textarea solo flat v-model="activeSpeech.description" prepend-inner-icon="mdi-information"></v-textarea>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'SpeechMeta',
  props: {
    activeSpeech: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
